import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import {
  OpalApiComponent,
  OpalApiRequestBody,
  OpalApiResponseDocument,
} from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateBoardV3'>['data']['attributes']
type RequestRelationships = Omit<
  OpalApiResponseDocument<'ReadBoardV3', 200>['data']['relationships'],
  'board_objects' | 'object_collections'
>

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'board'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultBoardAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  description: null,
  is_archived: false,
  is_public: false,
  updated_at: new Date().toISOString(),
}

const defaultBoardRelationships = {
  board_objects: {
    data: [],
  },
  board_collaborators: {
    data: [],
  },
  collaborators: {
    data: [],
  },
  object_collections: {
    data: [],
  },
  board_columns: {
    data: [],
  },
  default_story: {
    data: null,
  },
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes & Partial<OptionalAttributes>
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'board'> => {
  return {
    id: uuidv4(),
    type: 'board',
    attributes: {
      ...defaultBoardAttributes,
      ...attributes,
    },
    relationships: {
      ...defaultBoardRelationships,
      ...relationships,
    },
    meta: {
      pending: true,
    },
  }
}
